"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipHeaderTitle = exports.TooltipHeaderContent = exports.TooltipHeaderContainer = exports.TooltipHeaderCloseButton = exports.StyledVideoWrapper = exports.StyledGrid = exports.StyledBoxModal = exports.IconAndTitleWrapper = exports.Headline = exports.Header = exports.Content = exports.Container = exports.Button = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _theme = _interopRequireDefault(require("../../theme"));
var _Grid = _interopRequireDefault(require("../Grid"));
var _Heading = _interopRequireDefault(require("../Heading"));
var _focus = require("../../styles/focus");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var fadeIn = (0, _styledComponents.keyframes)(["0%{opacity:0;visibility:hidden;transform:scale(0.9);}100%{opacity:1;visibility:visible;transform:scale(1);}"]);
var Container = exports.Container = _styledComponents["default"].div.withConfig({
  displayName: "styled-components__Container",
  componentId: "sc-dew2rg-0"
})(["display:flex;align-items:center;background:rgba(8,5,28,0.8);position:fixed;bottom:0;top:0;left:0;right:0;z-index:99999;overflow-y:auto;overscroll-behavior:contain;"]);
var StyledGrid = exports.StyledGrid = (0, _styledComponents["default"])(_Grid["default"]).withConfig({
  displayName: "styled-components__StyledGrid",
  componentId: "sc-dew2rg-1"
})(["", " max-height:100vh;height:", ";", ""], function (_ref) {
  var isFullScreen = _ref.isFullScreen,
    isVideoModal = _ref.isVideoModal;
  if (isVideoModal) {
    return "padding: 0;";
  }
  if (isFullScreen) {
    return "padding: 0;";
  }
  return "padding: ".concat(_theme["default"].space20, ";");
}, function (_ref2) {
  var isFullScreen = _ref2.isFullScreen;
  return isFullScreen ? '100%' : 'auto';
}, _theme["default"].mediaMediumPlus(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    height:auto;\n    padding: ", ";\n "])), function (_ref3) {
  var isVideoModal = _ref3.isVideoModal;
  return isVideoModal ? '0' : _theme["default"].space40;
}));
var StyledBoxModal = exports.StyledBoxModal = _styledComponents["default"].div.withConfig({
  displayName: "styled-components__StyledBoxModal",
  componentId: "sc-dew2rg-2"
})(["animation:", " 300ms forwards;grid-column:1/-1;background:", ";border-radius:", ";flex-direction:column;display:flex;min-height:", ";box-sizing:border-box;", " ", ""], fadeIn, function (_ref4) {
  var background = _ref4.background;
  return background;
}, function (_ref5) {
  var isFullScreen = _ref5.isFullScreen;
  return isFullScreen ? "".concat(_theme["default"].radii.borderRadius20, " ").concat(_theme["default"].radii.borderRadius20, " 0 0") : "".concat(_theme["default"].radii.borderRadius20);
}, function (_ref6) {
  var hasMinHeight = _ref6.hasMinHeight;
  return hasMinHeight ? '200px' : 0;
}, _theme["default"].mediaMediumPlus(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    min-height: ", ";\n    border-radius: ", ";\n "])), function (_ref7) {
  var hasMinHeight = _ref7.hasMinHeight;
  return hasMinHeight ? '320px' : 0;
}, _theme["default"].radii.borderRadius20), _theme["default"].mediaLargePlus(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    grid-column: 3/11;\n "]))));
var Header = exports.Header = _styledComponents["default"].header.withConfig({
  displayName: "styled-components__Header",
  componentId: "sc-dew2rg-3"
})(["display:flex;justify-content:", ";align-items:center;padding:0 ", ";flex:0 0 ", ";", " ", ""], function (_ref8) {
  var onlyCloseButton = _ref8.onlyCloseButton,
    isVideoModal = _ref8.isVideoModal;
  return onlyCloseButton || isVideoModal ? 'flex-end' : 'space-between';
}, function (_ref9) {
  var isFullScreen = _ref9.isFullScreen;
  return isFullScreen ? "".concat(_theme["default"].space30) : "".concat(_theme["default"].space20);
}, function (_ref10) {
  var isFullScreen = _ref10.isFullScreen;
  return isFullScreen ? '72px' : "".concat(_theme["default"].space80);
}, _theme["default"].mediaMediumPlus(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    flex: 0 0 72px;\n    padding: 0 ", ";\n  "])), _theme["default"].space30), _theme["default"].mediaLargePlus(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref11) {
  var isVideoModal = _ref11.isVideoModal;
  return isVideoModal ? 'padding: 0;' : '';
}));
var Headline = exports.Headline = (0, _styledComponents["default"])(_Heading["default"]).withConfig({
  displayName: "styled-components__Headline",
  componentId: "sc-dew2rg-4"
})(["text-align:center;flex:1;"]);
var Button = exports.Button = _styledComponents["default"].button.withConfig({
  displayName: "styled-components__Button",
  componentId: "sc-dew2rg-5"
})(["display:flex;background:none;cursor:pointer;border:0;padding:0;", ""], _focus.focusStylesWithRoundedEdges);
var Content = exports.Content = _styledComponents["default"].article.withConfig({
  displayName: "styled-components__Content",
  componentId: "sc-dew2rg-6"
})(["", " word-wrap:break-word;flex-grow:1;overflow:auto;max-height:calc(100vh - 96px);> p{line-height:1.5;}", " ", ""], function (_ref12) {
  var hasHeader = _ref12.hasHeader,
    isFullScreen = _ref12.isFullScreen,
    isVideoModal = _ref12.isVideoModal;
  if (isVideoModal) {
    return 'padding: 0;';
  }
  if (hasHeader) {
    if (isFullScreen) {
      return "padding: 0 ".concat(_theme["default"].space30, " ").concat(_theme["default"].space30, ";");
    }
    return "padding: 0 ".concat(_theme["default"].space20, " ").concat(_theme["default"].space30, ";");
  }
  if (isFullScreen) {
    return "padding: ".concat(_theme["default"].space30, ";");
  }
  return "padding: ".concat(_theme["default"].space30, " ").concat(_theme["default"].space20, ";");
}, _theme["default"].mediaMediumPlus(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    max-height: calc(100vh - 136px);\n    ", "\n "])), function (_ref13) {
  var hasHeader = _ref13.hasHeader,
    spacing = _ref13.spacing,
    isVideoModal = _ref13.isVideoModal;
  if (isVideoModal) {
    return 'padding: 0;';
  }
  if (spacing === 'large') {
    if (hasHeader) return "padding: 0 ".concat(_theme["default"].space50, " ").concat(_theme["default"].space80, ";");
    return "padding: ".concat(_theme["default"].space50, ";");
  }
  if (spacing === 'medium') {
    return "padding: 9% ".concat(_theme["default"].space80, ";");
  }
  return "padding: 17% ".concat(_theme["default"].space80, ";");
}), _theme["default"].mediaLargePlus(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    ", "\n"])), function (_ref14) {
  var hasHeader = _ref14.hasHeader,
    spacing = _ref14.spacing,
    isVideoModal = _ref14.isVideoModal;
  if (isVideoModal) {
    return 'padding: 0;';
  }
  if (spacing === 'large') {
    if (hasHeader) return "padding: 0 ".concat(_theme["default"].space60, " ").concat(_theme["default"].space80, ";");
    return "padding: ".concat(_theme["default"].space50, ";");
  }
  if (spacing === 'medium') {
    return "padding: 0 13% ".concat(_theme["default"].space80, ";");
  }
  return "padding: 0 26% ".concat(_theme["default"].space80, ";");
}));
var TooltipHeaderContainer = exports.TooltipHeaderContainer = _styledComponents["default"].div.withConfig({
  displayName: "styled-components__TooltipHeaderContainer",
  componentId: "sc-dew2rg-7"
})(["display:flex;flex-direction:column;margin:", " ", " ", " ", ";", " ", ""], _theme["default"].space30, _theme["default"].space30, _theme["default"].space20, _theme["default"].space30, _theme["default"].mediaMediumPlus(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n   flex-direction: row-reverse;\n   justify-content: space-between;\n   margin-left: ", ";\n "])), _theme["default"].space50), _theme["default"].mediaLargePlus(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n   margin-left: ", ";\n "])), _theme["default"].space60));
var TooltipHeaderTitle = exports.TooltipHeaderTitle = _styledComponents["default"].div.withConfig({
  displayName: "styled-components__TooltipHeaderTitle",
  componentId: "sc-dew2rg-8"
})(["display:flex;align-items:center;margin-left:", ";"], _theme["default"].space20);
var IconAndTitleWrapper = exports.IconAndTitleWrapper = _styledComponents["default"].header.withConfig({
  displayName: "styled-components__IconAndTitleWrapper",
  componentId: "sc-dew2rg-9"
})(["display:flex;", ""], _theme["default"].mediaMediumPlus(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    margin-top: ", ";\n "])), _theme["default"].space20));
var TooltipHeaderCloseButton = exports.TooltipHeaderCloseButton = _styledComponents["default"].button.withConfig({
  displayName: "styled-components__TooltipHeaderCloseButton",
  componentId: "sc-dew2rg-10"
})(["display:flex;background:none;cursor:pointer;border:0;padding:0;margin-bottom:40px;align-self:flex-end;", " ", ""], _theme["default"].mediaMediumPlus(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n   margin-bottom: 0;\n   align-self: flex-start;\n "]))), _focus.focusStylesWithRoundedEdges);
var TooltipHeaderContent = exports.TooltipHeaderContent = _styledComponents["default"].article.withConfig({
  displayName: "styled-components__TooltipHeaderContent",
  componentId: "sc-dew2rg-11"
})(["word-wrap:break-word;flex-grow:1;overflow:auto;max-height:calc(100vh - 96px);margin:0 ", " ", " ", ";> p{line-height:24px;}", " ", ""], _theme["default"].space30, _theme["default"].space30, _theme["default"].space30, _theme["default"].mediaMediumPlus(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n        margin: 0 ", " ", " ", ";\n      "])), _theme["default"].space50, _theme["default"].space50, _theme["default"].space50), _theme["default"].mediaLargePlus(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n        margin: 0 ", " ", " ", ";\n     "])), _theme["default"].space60, _theme["default"].space60, _theme["default"].space60));
var StyledVideoWrapper = exports.StyledVideoWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styled-components__StyledVideoWrapper",
  componentId: "sc-dew2rg-12"
})(["position:relative;padding-bottom:56.25%;iframe{position:absolute;top:0;left:0;width:100%;height:100%;}"]);